import { render, staticRenderFns } from "./TaxableRebateLimitEdit.vue?vue&type=template&id=671027fa"
import script from "./TaxableRebateLimitEdit.vue?vue&type=script&lang=js"
export * from "./TaxableRebateLimitEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports